module.exports = __webpack_public_path__ + "components/flag/static/square/eh-1e2a474a86cc963dd4b1e044c9aa317c.svg";